import { Input, InputNumber, Radio, Slider, Space, Switch } from 'antd';
import { Parameter } from 'api';
import Typography from 'helpers/fonts';
import React, { useState } from 'react';
import Colors from '../colors';
import { COLORS } from '../materialssidebar/tabpane';

interface ParameterProps {
  parameter: Parameter;
  onChange: (value: any) => void;
}

const ParameterCard: React.FunctionComponent<ParameterProps> = ({
  parameter,
  onChange,
}) => {
  const [value, setValue] = useState(
    parameter.defaultValue === "true"
      ? true
      : parameter.defaultValue === "false"
        ? false
        : parameter.defaultValue || undefined
  );

  const onValueChange = (value: any) => {
    setValue(value);
    onChange(value);
  };

  return (
    <div>
      <div style={{ marginBottom: 12 }}>
        <Typography styleid={6}>{parameter.name}</Typography>
      </div>
      {
        {
          BOOLEAN: <Switch checked={!!value} onChange={onValueChange} />,
          NUMBER: (
            <InputNumber value={value as number} onChange={onValueChange} />
          ),
          STRING: (
            <Input
              value={value as string}
              onChange={(e) => onValueChange(e.target.value)}
            />
          ),
          RANGE: (
            <Slider
              min={parameter.min as number}
              max={parameter.max as number}
              onChange={onValueChange}
              defaultValue={value as number}
            />
          ),
          SELECT: (
            <Radio.Group
              value={value}
              onChange={(e) => onValueChange(e.target.value)}
            >
              <Space size={[8, 8]} wrap>
                {parameter.options.map((o) => (
                  <Radio.Button  key={o.label} value={o.value}>
                    {o.label}
                  </Radio.Button>
                ))}
              </Space>
            </Radio.Group>
          ),
          COLOR: (
            <Colors
              colors={COLORS}
              selectedColor={value as string}
              onSelectColor={onValueChange}
            />
          ),
        }[parameter.type]
      }
      <div style={{ marginTop: 12 }}>
        <Typography styleid={7}>{parameter.description}</Typography>
      </div>
    </div>
  );
};

export default ParameterCard;
